import LText from "@components/LText";
import LIcon from "@components/LIcon";
import {
  MUSIC_ACCESS_FLOW_COPY,
  type MusicAccessDetailsModel,
} from "@libs/shared-ui";
import Button from "../common/Button";
import type { MusicUnlockPorts } from "./musicUnlock";
import { MusicUnlockSheet } from "./MusicUnlockSheet";

/**
 * Details' Unlock (LIS-1038): opens the unlock's sheet, as Get tickets
 * opens the tickets', free or paid — the music, the fan's sign-in, then
 * Continue: a free unlock (no price, or a valid unlock code) completes on
 * the server and ends on "It's yours"; one with a price goes on to the
 * same checkout as a ticket's.
 */
export function MusicUnlockButton({
  model,
  dataSharingConsent,
  ports,
}: {
  model: MusicAccessDetailsModel;
  /** Recorded with the order; unlocking waits while it is unchecked. */
  dataSharingConsent?: boolean;
  ports: MusicUnlockPorts;
}) {
  const signedIn = ports.buyer.user !== null;
  const consent = dataSharingConsent === true;

  const unlock = () => {
    const { kind } = model.primaryAction;
    if (kind !== "unlock-free" && kind !== "checkout") return;
    ports.openSheet(({ close, ports: inSheet }) => (
      <MusicUnlockSheet
        model={model}
        dataSharingConsent={consent}
        ports={inSheet}
        close={close}
      />
    ));
  };

  return (
    <Button.Button
      disabled={dataSharingConsent === false}
      onPress={unlock}
      sentryEventName={
        signedIn ? "AccessDetail.Unlock" : "AccessDetail.LoginPrompt"
      }
    >
      <LIcon colors={{ color: "black" }} name="lock_locked" size={16} />
      <LText variant="Caption/C1/Medium" color="black">
        {signedIn
          ? MUSIC_ACCESS_FLOW_COPY.unlock
          : MUSIC_ACCESS_FLOW_COPY.loginToUnlock}
      </LText>
    </Button.Button>
  );
}
